export enum SemitrailerType {
    SingleAxleSemitrailer = 0,
    TwoAxleSemitrailer = 1,
    ThreeAxleSemitrailer = 2,
    FourAxleSemitrailer = 3,
  }